import { useAuth0 } from "@auth0/auth0-react";
import { IconButton, TableContainer } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import AddIcon from "@mui/icons-material/Add";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import Paper from "@mui/material/Paper";
import { ReactComponent as PayNowSvg } from "assets/icons/Property.svg";
import { ReactComponent as ShareSvg } from "assets/icons/Share.svg";
import { ReactComponent as PlusIcon } from "assets/icons/plus.svg";
import sortImg from "assets/icons/sort-able-svg.svg";
import { MyCheckbox } from "components";
import AlertDialog from "components/Dialog/index";
import MyButton from "components/MyButton";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import { debounce } from "lodash";
import ShareDocumentsModal from "pages/NewFinance/Documents/ShareDocumentsModal/index";
import React, { memo, useCallback, useEffect, useState } from "react";
import { BsSortDown } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import FinanceService from "../../../../Lib/API/Finance";
import { SetRecurringChecks } from "../../../../app/redux/actions/index";
import MyModal from "../../../../components/MyModal";
import NotAuthorized from "../../../../components/NotAuthorized";
import NewCharge from "../../../../pages/NewFinance/NewCharge";
import UserContext from "../../../../pages/NewFinance/NewChargeContext";
import { setAccountTransaction } from "../../../../pages/commonSlice";
import { PayNow } from "../../../../store/redux/actions";

import ManagePaymentMethods from "components/ManagePaymentMethods";
import NewDialog from "components/NewDialog/Dialog";
import UpdatePaymentMethod from "components/UpdatePaymentMethod/index";
import Button from "components/button/Button";
import ClearGroupFilter from "components/clearGroupFilter";
import FilterTabs from "components/filterTabs/FilterTabs";
import { numberFormat } from "helper";
import { useLocation } from "react-router-dom";
import {
  HidePaymentInfoButton,
  dispacthPayNowRow,
} from "../../../../store/redux/actions/index";
import FinanceDrawer from "../../../NewFinance/Drawer";
import ExpandableRow from "../../../NewFinance/TransationTableComponents/ExpandableRow";

const initial = 0;

const ChargesTable = ({
  rowsPerPage,
  setRowsPerPage,
  filters,
  setFilters,
  sortData,
  sortCharged,
  list,
  batchTable,
  memberId,
  account,
  onStatusChange,
  viewDocumentHandler,
  downloadFileHandler,
  documentHandler,
  viewLetterHandler,
  setRefresh,
}) => {
  const RecurringModel = useSelector(
    (state) => state.homeReducer.RecurringModelCheck
  );
  const confirmEditTransaction = React.useRef(false);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const paymentIdParam = searchParams.get("paymentId");
  const bulkPaymentIdParam = searchParams.get("bulkPaymentId");

  const [openModal, setOpenModal] = React.useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [currentAccount, setCurrentAccount] = useState(null);
  const [financeCheckIds, setFinanceCheckIds] = useState([]);
  const [check, setCheck] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [productData, setProductData] = useState();
  const [count, setCount] = useState();
  const [checkData, setCheckData] = useState([]);
  const [stepper, setStepper] = useState("New Charge");
  const [savetribute, setsavetribute] = useState(false);
  const [page, setPage] = useState(initial);
  // const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const dispatch = useDispatch();
  const [batchList, setbatchList] = useState(false);
  const [isFinanceActive, setIsFinanceActive] = useState(true);
  const [showModel, setShowModel] = useState(false);
  const [isSaved, setSaved] = useState(false);
  const [hfinish, setHFinish] = useState(false);
  const [open, setOpen] = useState(false);
  const [stepOne, setStepOne] = useState(true);
  const [accountTransactionModal, setAccountTransactionModal] = useState(false);
  const [expandable, setExpandable] = useState(true);
  const [data, setData] = useState({});
  const [paymentAction, setPaymentAction] = useState(false);
  const [switchType, setSwitchType] = useState(
    paymentIdParam || bulkPaymentIdParam ? "payment" : "charge"
  );
  const [bulkSort, setBulkSort] = useState({});
  const [openSharePaymentModal, setOpenSharePayment] = useState(false);
  const [openPaymentMethodsModal, setOpenPaymentMethodsModal] = useState(false);
  const [copyPaymentLink, setCopyPaymentLink] = useState(false);
  const [openConfirmEditInstallmentModal, setOpenConfirmEditInstallmentModal] =
    useState(false);
  const [transactionRowData, setTransactionRowData] = useState({});
  const [
    openConfirmCancelInstallmentModal,
    setOpenConfirmCancelInstallmentModal,
  ] = useState(false);
  const [cancelInstallmentLoading, setCancelInstallmentLoading] =
    useState(false);
  const [dataRowSharePayment, setDataRowSharePayment] = useState({});
  const [confirmClose, setConfirmClose] = useState(false);
  const [updatePaymentMethod, setUpdatePaymentMethod] = useState({
    open: false,
    data: null,
  });
  const [paymentModal, setPaymentModal] = useState(false);
  const onSharePaymentLinkClick = (row) => {
    setOpenSharePayment(!openSharePaymentModal);
    const paymentLink = row?.charge?._id
      ? `${account?.paymentLink}&chargeId=${row?.charge?._id}`
      : account?.paymentLink;
    setCopyPaymentLink(paymentLink);
    setDataRowSharePayment(row);
  };
  const handleBulkSort = (name) => {
    setPage(0);
    setBulkSort((prev) => ({
      [name]: prev[name] === 1 ? -1 : 1,
    }));
  };

  const addNewTransaction = () => {
    dispatch(SetRecurringChecks("hide"));

    dispatch(HidePaymentInfoButton(false));

    dispatch(
      dispacthPayNowRow({
        tribute_info: {
          type: "",
          recipient_name: "",
          donor_name: "",
          assign_tribute: "",
          receipt: {
            id: "",
            name: "",
          },
          message: "",
          recipient_salutation: "",
          donor_salutation: "",
          send_letter_to: {
            email: "",
            address: "",
          },
        },
      })
    );
    setData({});
    setCheckData([]);
    setCheck([]);
    setFinanceCheckIds([]);
    setOpen(true);
  };

  useEffect(() => {
    if (open) {
      setCheckData([]);
      setCheckData([]);
      setCheck([]);
      setFinanceCheckIds([]);
    }
  }, [open]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCheck([]);
  }, [batchList]);

  useEffect(() => {
    setSwitchType(paymentIdParam || bulkPaymentIdParam ? "payment" : "charge");
    setPage(0);
    if (paymentIdParam || bulkPaymentIdParam) {
      getBulkPayments(0);
    } else {
      fetchMyAPI();
    }
  }, [paymentIdParam, bulkPaymentIdParam]);

  const PayNowData = useSelector((state) => state.homeReducer.paynowValue);
  const RecurringModelCheck = useSelector(
    (state) => state.homeReducer.RecurringModelCheck
  );

  useEffect(() => {
    setPage(0);
  }, []);

  useEffect(() => {
    if (switchType === "payment") {
      getBulkPayments(page);
    } else {
      fetchMyAPI();
    }
    if (paymentAction) {
      setPaymentAction(false);
    }
  }, [savetribute, paymentAction, RecurringModelCheck]);

  const [balance, setBalance] = useState(null);

  useEffect(() => {
    if (balance === null) {
      fetchAmountApi();
    }
  }, [balance]);

  const fetchAmountApi = async (e) => {
    const token = await getAccessTokenSilently();
    setLoading(true);
    await FinanceService.getAmountByAccountId(token, account?._id)
      .then((res) => {
        const result = res;
        setLoading(false);

        setBalance(result);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  const fetchMyAPI = async (e) => {
    setProductData([]);
    const token = await getAccessTokenSilently();
    setLoading(true);
    setBalance(null);
    if (filters?.filter?.charge_status) {
      delete filters?.filter?.charge_status;
    }
    await FinanceService.getTransactionsByID(token, page + 1, 30, filters)
      .then((res) => {
        const result = res?.payload?.data;
        setSwitchType("charge");
        setLoading(false);

        setProductData(result);
        setCount(res?.payload?.pagination?.count);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  const getBulkPayments = async (page) => {
    setProductData([]);
    const token = await getAccessTokenSilently();
    const payload = {
      filter: {
        method: "all",
        accountId: account?._id,
        charge_type: filters?.filter?.charge_type
          ? filters?.filter?.charge_type
          : undefined,
        charge_status: filters?.filter?.charge_status
          ? filters?.filter?.charge_status
          : undefined,
        ...(paymentIdParam ? { id: paymentIdParam } : {}),
        ...(bulkPaymentIdParam ? { id: bulkPaymentIdParam } : {}),
      },
      sort: bulkSort,
    };
    if (filters?.status) {
      delete filters?.status;
    }
    try {
      setLoading(true);
      const res = await FinanceService.getBulkPayments(
        token,
        page + 1,
        30,
        payload
      );
      const result = res?.payload?.data;
      setProductData(result);
      setCount(res?.payload?.pagination?.count);
    } catch (error) {
      toastr.error("Error", error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const debounceSearch = useCallback(
    debounce(() => {
      if (filters?.search) {
        fetchMyAPI();
      }
    }, 1000),
    [filters?.search, filters]
  );

  useEffect(() => {
    if (switchType === "payment") {
      getBulkPayments(page);
    } else if (filters?.search) {
      debounceSearch();
    } else {
      fetchMyAPI();
    }
    return () => debounceSearch.cancel();
  }, [filters?.search, filters, page, bulkSort]);

  const fetchApis = () => {
    fetchMyAPI();
  };

  useEffect(() => {
    window.addEventListener("save-transaction", fetchApis);
    return () => {
      window.removeEventListener("save-transaction", fetchApis);
    };
  }, [filters, sortData, page, getAccessTokenSilently]);

  const onPayNowClick = (row) => {
    dispatch(PayNow({ detail: row }));
    setData({
      ...row,
      type: "pay-now",
    });

    setShowModel(true);
    setOpen(true);
    window.dispatchEvent(new CustomEvent("pay-now", { detail: row }));
    dispatch(setAccountTransaction(account));
  };

  const onModalClose = () => {
    if (isSaved || hfinish) {
      closeModal();
      dispatch(SetRecurringChecks("hide"));
      // localStorage.setItem("setRecurring", "false");
    } else {
      closeModal();
      dispatch(SetRecurringChecks("hide"));
      // localStorage.setItem("setRecurring", "false");
    }
  };

  const [selectedRow, setSelectedRow] = useState(null);
  const [openModalDialog, setOpenModalDialog] = React.useState(false);

  const onDeleteClick = async (row) => {
    setOpenModalDialog(true);
    setSelectedRow(row);
  };

  const handleCloseDialog = () => {
    setOpenModalDialog(false);
  };

  const handleSubmit = async () => {
    const token = await getAccessTokenSilently();
    const isRecurring = selectedRow?.isRecurring;

    await FinanceService.deleteTransaction(
      selectedRow,
      token,
      isRecurring ? selectedRow?.charge?._id : ""
    )
      .then((res) => {
        if (res) {
          toastr.success("Transaction deleted successfully");
          fetchMyAPI();
          setPaymentAction(true);
          setOpenModalDialog(false);
        }
      })
      .catch((err) => {
        setPaymentAction(true);
        toastr.error(err?.data?.message);
        setOpenModalDialog(false);
      });
  };

  const confirmCancelInstallmentHandler = async () => {
    if (cancelInstallmentLoading) return;
    setCancelInstallmentLoading(true);
    const token = await getAccessTokenSilently();
    const payload = {
      installmentId:
        transactionRowData?.charge?.installmentDetails?.installmentId,
      chargeId: transactionRowData?.charge?._id,
    };

    await FinanceService.cancelInstallment(token, payload)
      .then((res) => {
        if (res) {
          setOpenConfirmCancelInstallmentModal(false);
          toastr.success("Success", "Installment Cancelled Successfully");
          fetchMyAPI();
        }
      })
      .catch((error) => {
        toastr.error(error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setCancelInstallmentLoading(false);
      });
  };

  const onCancelPayment = (row) => {
    setOpenConfirmCancelInstallmentModal(true);
    setTransactionRowData(row);
  };

  const openConfirmEditInstallmentModalHandler = (row) => {
    confirmEditTransaction.current = false;
    setOpenConfirmEditInstallmentModal(true);
    setTransactionRowData(row);
  };

  const onUpdateClick = async (row) => {
    if (
      !confirmEditTransaction.current &&
      row?.charge?.installmentDetails?.status === "active"
    ) {
      return openConfirmEditInstallmentModalHandler(row);
    }
    confirmEditTransaction.current = false;

    setOpen(true);
    setData({
      ...row,
      type: "edit-charge",
    });
    dispatch(HidePaymentInfoButton(true));
    setAccountTransactionModal(true);
    dispatch(setAccountTransaction(account));
  };

  const closeModal = () => {
    setStepOne(true);
    setOpen(false);
    setAccountTransactionModal(false);
  };

  const onReversalClick = async (id, setReversalActionTypes) => {
    const token = await getAccessTokenSilently();
    setLoading(true);
    await FinanceService.reverseCharge(id, token)
      .then(() => {
        setLoading(false);
        toastr.success("Success", "Charge has been reversed");
      })
      .catch((error) => {
        setLoading(false);
        toastr.error(
          error?.data?.message || "Something went wrong, please try again later"
        );
      });
    fetchMyAPI();
    setReversalActionTypes(false);
  };

  const onPayAllClick = (detail) => {
    setData({
      allData: detail,
      type: "pay-all",
    });
    setOpen(true);
    setShowModel(true);
  };

  useEffect(() => {
    document.addEventListener("pay-all", onPayAllClick);
    return () => document.removeEventListener("pay-all", onPayAllClick);
  }, []);

  const onCheckboxChange = (e, row, index, page) => {
    setCheckData((prev) => [...prev, row]);

    const { checked } = e.target;
    if (!checked) {
      setCheck((prev) => {
        const checkClone = prev.filter((item) => item !== row?.charge?._id);
        if (!checkClone.length) {
          setCurrentAccount(null);
        }
        return [...checkClone];
      });

      setCheckData((prev) => {
        const checkClone = prev.filter(
          (item) => item?.charge?._id !== row?.charge?._id
        );
        if (!checkClone.length) {
          setCurrentAccount(null);
        }
        return [...checkClone];
      });
      return;
    }

    if (!currentAccount) setCurrentAccount(row?.Account?.id);
    if (currentAccount === row?.Account?.id || !currentAccount) {
      setCheck((prev) => [...prev, row?.charge?._id]);
      setFinanceCheckIds((prev) => [row?.Account?.id]);
    }
  };

  const modifyRowData = (row, item) => {
    const modified = {
      ...row,
      charge: { ...row.charge },
      ...item,
      transactionId: row?._id,
    };
    setDrawerData(modified);
    setOpenModal(true);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "finance") {
        return setIsFinanceActive(item?.active);
      }
    });
  }, []);

  const filter_by =
    switchType === "charge"
      ? ["All", "Charge", "Payment", "COA"]
      : ["All", "Partial", "Paid", "COA"];
  const filterTabs =
    switchType === "charge"
      ? [
          {
            title: "All",
            value: "All",
          },
          {
            title: "Charge",
            value: "Charge",
            dotColor: "#FBA12C",
          },
          {
            title: "Payment",
            value: "Payment",
            dotColor: "#81DC91",
          },
          {
            title: "COA",
            value: "COA",
            dotColor: "#2555ef",
          },
        ]
      : [
          {
            title: "All",
            value: "All",
          },
          {
            title: "Partial",
            value: "Partial",
            dotColor: "#FBA12C",
          },
          {
            title: "Paid",
            value: "Paid",
            dotColor: "#81DC91",
          },
          {
            title: "COA",
            value: "COA",
            dotColor: "#2555ef",
          },
        ];

  const selectCurrentStatus = () => {
    if (filters?.filter?.charge_type === "credit_on_account") {
      return "COA";
    } else if (filters?.filter?.charge_status === "partially_paid") {
      return "Partial";
    } else if (filters?.filter?.charge_status === "closed") {
      return "Paid";
    } else if (filters?.status) {
      return filters?.status;
    }
    return "All";
  };

  const intValue = balance !== null && parseFloat(balance?.balance);
  const formatedBalance = numberFormat({
    number: intValue,
    decimal: 2,
    style: "currency",
  });

  const intValueCred = balance !== null && parseFloat(balance?.creditOnAccount);
  const formatedCreditOnAccount = numberFormat({
    number: intValueCred,
    decimal: 2,
    style: "currency",
  });

  const intValueOver = balance !== null && parseFloat(balance?.overDue);
  const formatedOverdue = numberFormat({
    number: intValueOver,
    decimal: 2,
    style: "currency",
  });

  const closeFinanceModal = () => {
    if (RecurringModel) return onModalClose();
    setConfirmClose(true);
  };

  const confirmCloseFinanceModal = () => {
    setConfirmClose(false);
    if (openPaymentMethodsModal) {
      return setOpenPaymentMethodsModal(false);
    }
    if (openSharePaymentModal) {
      setOpenSharePayment(false);
      setDataRowSharePayment({});
      return;
    }
    onModalClose();
  };

  const closeManagePaymentMethods = () => {
    setConfirmClose(true);
  };

  const closeSharePaymentModal = (close = false) => {
    if (close) {
      return setOpenSharePayment(false);
    }
    setConfirmClose(true);
  };

  const onUpdatePaymentMethodClick = (row) => {
    setUpdatePaymentMethod({ open: true, data: row });
  };

  const closeUpdatePaymentMethod = () => {
    setUpdatePaymentMethod({ open: false, data: null });
  };
  const handlePaymentOpen = () => setPaymentModal(true);
  const closePaymentModal = () => setPaymentModal(false);

  return isFinanceActive == false ? (
    <NotAuthorized title={"Finances"} />
  ) : (
    <div className="w-100">
      <div
        className="mb-4"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {balance !== null ? (
          <div
            style={{
              border: "1px solid rgb(0 46 92 / 17%)",
              borderRadius: "9px",
              height: "45px",
              padding: "12px 18px",
            }}
          >
            <span className="dot" style={{ "--my-color": "#81DC91" }}></span>
            Credit on Account{" "}
            <span className="amountBold mr-3">
              {formatedCreditOnAccount}
            </span> |{" "}
            <span
              className="dot ml-3"
              style={{ "--my-color": "#2555EF" }}
            ></span>
            Balance <span className="amountBold mr-3">{formatedBalance}</span> |{" "}
            <span
              className="dot ml-3"
              style={{ "--my-color": "#F1585E" }}
            ></span>
            Over Due({balance?.numberOfOverDueCharges ?? 0}){" "}
            <span className="amountBold mr-3">{formatedOverdue}</span>
          </div>
        ) : (
          <p>loading...</p>
        )}
        <FilterTabs
          tabs={filterTabs}
          activeTab={selectCurrentStatus()}
          onTabsChange={(tab) => {
            onStatusChange(tab?.value);
          }}
          style={{
            minHeight: "45px",
          }}
        />
      </div>

      <div className={"family-table-container pl-7 pr-6 pt-3 pb-22"}>
        <div className="home-table-container mt-0 no-box-shadow">
          <>
            <div className="d-flex justify-content-between mb-5 h-40px">
              <div
                className="d-flex align-items-center"
                style={{
                  gap: "15px",
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{
                    height: "36px",
                    backgroundColor: "#e7edf9",
                    borderRadius: "4px",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => {
                      if (loading) return;
                      setPage(0);
                      setSwitchType("charge");
                      fetchMyAPI();
                    }}
                    className={
                      switchType === "charge"
                        ? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
                        : `btn btn-clean font-weight-bold m-2 d-flex align-items-center`
                    }
                    style={
                      switchType === "charge"
                        ? { color: "#FFFFFF", height: "24px" }
                        : { color: "#2555EF", height: "24px" }
                    }
                    disabled={loading}
                  >
                    Charges
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      if (loading) return;
                      setSwitchType("payment");
                      setPage(0);
                      getBulkPayments(0);
                    }}
                    className={
                      switchType === "payment"
                        ? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
                        : `btn btn-clean font-weight-bold m-2 d-flex align-items-center`
                    }
                    style={
                      switchType === "payment"
                        ? { color: "#FFFFFF", height: "24px" }
                        : { color: "#2555EF", height: "24px" }
                    }
                    disabled={loading}
                  >
                    Payments
                  </button>
                </div>
                {(paymentIdParam || bulkPaymentIdParam) && <ClearGroupFilter />}
              </div>

              <div className="finance-button">
                {checkData?.length > 0 && (
                  <Button
                    variant="primary"
                    onClick={() => {
                      onPayAllClick(checkData);
                    }}
                    size="md"
                  >
                    <PayNowSvg />
                    <span>Pay All</span>
                  </Button>
                )}
                {!checkData.length && (
                  <Button
                    variant="secondary-light"
                    size="md"
                    onClick={() => {
                      setOpenPaymentMethodsModal(true);
                    }}
                    style={{
                      marginRight: "1rem",
                    }}
                  >
                    <span>
                      <CreditCardOutlinedIcon fontSize="medium" />
                    </span>
                    <span>Payment Methods</span>
                  </Button>
                )}
                {!checkData.length && (
                  <Button
                    variant="secondary-light"
                    size="md"
                    onClick={() => onSharePaymentLinkClick(data)}
                    disabled={!account?.sharePaymentLink}
                    style={{
                      marginRight: "1rem",
                    }}
                  >
                    <ShareSvg />
                    <span>Share Payment Link</span>
                  </Button>
                )}
                {!checkData.length && (
                  <Button
                    variant="primary"
                    onClick={() => {
                      dispatch(setAccountTransaction(account));
                      addNewTransaction();
                      setAccountTransactionModal(true);
                    }}
                    size="md"
                  >
                    <PlusIcon />
                    <span>New Transaction</span>
                  </Button>
                )}
              </div>
            </div>
          </>

          <TableContainer component={Paper} className="scroll-table">
            <Table
              class="main-table charge-finance__table"
              aria-label="collapsible table"
            >
              <TableHead className="charges-table main-table__header sticky-table-header">
                <TableRow>
                  {/* <TableCell className="main-check" padding="checkbox">
                    <MyCheckbox name={"visible"} handlechange={() => { }} />
                  </TableCell> */}
                  <TableCell className="table-cell-remove" />
                  <TableCell className="table-cell-remove" />
                  <TableCell className="table-cell-remove" />

                  <TableCell className="date-head">
                    {switchType === "payment" ? "DATE" : "STATUS"}
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.status === 1 ? (
                          <BsSortDown onClick={() => sortCharged("status")} />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => sortCharged("status")}
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.paymentDate === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("paymentDate")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("paymentDate")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>
                  {switchType !== "payment" && (
                    <TableCell className="status-head" align="left">
                      CREATED DATE
                      <IconButton>
                        {filters?.sort?.tran_date === 1 ? (
                          <BsSortDown
                            onClick={() => sortCharged("tran_date")}
                          />
                        ) : (
                          <img
                            onClick={() => sortCharged("tran_date")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    </TableCell>
                  )}
                  <TableCell className="status-head" align="left">
                    DUE DATE
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.due_date === 1 ? (
                          <BsSortDown onClick={() => sortCharged("due_date")} />
                        ) : (
                          <img
                            onClick={() => sortCharged("due_date")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.dueDate === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("dueDate")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("dueDate")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>

                  {/* {switchType === "payment" && <TableCell className="status-head" align="left">
                    STATUS
                    <IconButton>
                      {bulkSort?.status === 1 ? (
                        <BsSortDown onClick={() => handleBulkSort("status")} />
                      ) : (
                        <img
                          onClick={() => handleBulkSort("status")}
                          src={sortImg}
                          alt="sort"
                        />
                      )}
                    </IconButton>
                  </TableCell>} */}
                  <TableCell className="charged-value" align="left">
                    CHARGED
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.charged === 1 ? (
                          <BsSortDown onClick={() => sortCharged("charged")} />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => sortCharged("charged")}
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.charged === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("charged")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("charged")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>
                  <TableCell align="left" className="paid-head">
                    PAID
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.total_paid === 1 ? (
                          <BsSortDown
                            onClick={() => sortCharged("total_paid")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => sortCharged("total_paid")}
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.paid === 1 ? (
                          <BsSortDown onClick={() => handleBulkSort("paid")} />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("paid")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>
                  {switchType !== "payment" && (
                    <TableCell
                      align="left"
                      className="paid-head"
                      style={{
                        paddingRight: "8rem",
                      }}
                    >
                      DUE
                      {switchType !== "payment" && (
                        <IconButton
                          style={{
                            display: "none",
                          }}
                        >
                          {filters?.sort?.due === 1 ? (
                            <BsSortDown
                            // onClick={() => sortCharged("due")}
                            />
                          ) : (
                            <img
                              src={sortImg}
                              alt="sort"
                              // onClick={() => sortCharged("due")}
                            />
                          )}
                        </IconButton>
                      )}
                    </TableCell>
                  )}
                  <TableCell className="ledger-head" align="left">
                    SUB LEDGER / LEDGER
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.ledger === 1 ? (
                          <BsSortDown onClick={() => sortCharged("ledger")} />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => sortCharged("ledger")}
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.ledger === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("ledger")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("ledger")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>
                  {switchType === "payment" && (
                    <TableCell className="ledger-head" align="left">
                      PAYMENT METHOD
                      <IconButton>
                        {bulkSort?.paymentMethod === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("paymentMethod")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("paymentMethod")}
                          />
                        )}
                      </IconButton>
                    </TableCell>
                  )}
                  {switchType === "payment" && (
                    <TableCell className="ledger-head" align="left">
                      PAYMENT ID
                    </TableCell>
                  )}
                  <TableCell
                    className="empty-head sticky-header-column"
                    align="left"
                  />
                </TableRow>
              </TableHead>

              {loading ? (
                <td colSpan={12}>
                  <div
                    className="record-text"
                    style={{
                      height: "500px",
                    }}
                  >
                    {" "}
                    <Loader />
                  </div>
                </td>
              ) : productData?.length === 0 ? (
                <td colSpan={12}>
                  <div className="record-text">No record found</div>
                </td>
              ) : productData ? (
                productData?.map((row, i) => (
                  <ExpandableRow
                    Enableloading={loading}
                    modifyRowData={modifyRowData}
                    setPaymentAction={setPaymentAction}
                    key={row.name}
                    row={row}
                    index={i}
                    hideAccountName={true}
                    onCheckboxChange={onCheckboxChange}
                    check={check}
                    onSharePaymentLinkClick={onSharePaymentLinkClick}
                    onPayNowClick={onPayNowClick}
                    onUpdateClick={onUpdateClick}
                    onDeleteClick={onDeleteClick}
                    onReversalClick={onReversalClick}
                    setDrawerData={setDrawerData}
                    setOpenModal={setOpenModal}
                    financeCheckIds={financeCheckIds}
                    expandable={expandable}
                    setExpandable={setExpandable}
                    checkData={checkData}
                    onPayAllClick={onPayAllClick}
                    bulkPayment={switchType === "payment" ? true : false}
                    disableSharePaymentLink={!account?.sharePaymentLink}
                    onCancelPayment={onCancelPayment}
                    onUpdatePaymentMethodClick={onUpdatePaymentMethodClick}
                  />
                ))
              ) : list?.length > 0 && batchTable === "batchtable" ? (
                list?.map((row, i) => (
                  <TableBody>
                    <ExpandableRow
                      modifyRowData={modifyRowData}
                      key={row.name}
                      row={row}
                      index={i}
                      onCheckboxChange={onCheckboxChange}
                      check={check}
                      onPayNowClick={onPayNowClick}
                      onReversalClick={onReversalClick}
                      setDrawerData={setDrawerData}
                      setOpenModal={setOpenModal}
                      batchTable={batchTable}
                      checkData={checkData}
                      onPayAllClick={onPayAllClick}
                      onUpdatePaymentMethodClick={onUpdatePaymentMethodClick}
                    />
                  </TableBody>
                ))
              ) : (
                <td colSpan={12}>
                  <div className="record-text">
                    {" "}
                    <Loader />
                  </div>
                </td>
              )}
            </Table>
          </TableContainer>
          {(productData?.length === 0 && list === 0) ||
          batchTable === "batchtable" ? (
            ""
          ) : (
            <div className="pagination-custom mt-2">
              <Pagination
                count={Math.ceil(count / 30)}
                color="primary"
                variant="outlined"
                onChange={(event, value) => {
                  setPage(value - 1);
                }}
                page={page + 1}
              />
            </div>
          )}
        </div>
        <RightDrawer
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
        >
          <FinanceDrawer
            data={drawerData}
            setsavetribute={setsavetribute}
            handleClose={() => setOpenModal(false)}
            onReversalClick={onReversalClick}
            onSharePaymentLinkClick={onSharePaymentLinkClick}
            viewDocumentHandler={viewDocumentHandler}
            downloadFileHandler={downloadFileHandler}
            documentHandler={documentHandler}
            viewLetterHandler={viewLetterHandler}
            switchType={switchType}
          />
        </RightDrawer>
      </div>
      <AlertDialog
        open={openModalDialog}
        handleClose={handleCloseDialog}
        onDecline={() => {
          setOpenModalDialog(false);
        }}
        onAccept={() => {
          handleSubmit();
        }}
        title={"Are you sure?"}
        description={
          "Deleting this transaction is non-reversible. Would you like to proceed?"
        }
      />

      {(data || accountTransactionModal) && (
        <MyModal
          className={stepOne ? "new-charge-modal" : "new-charge-modal-w"}
          open={open || accountTransactionModal}
          onClose={closeFinanceModal}
        >
          <UserContext.Provider value={{ hfinish, setHFinish }}>
            <NewCharge
              setStepOne={setStepOne}
              setStepper={setStepper}
              handleClose={onModalClose}
              data={data}
              // data={accountTransactionModal ? "" : PayNowData?.detail}
              activeIndex={accountTransactionModal ? 0 : 1}
              setSaved={setSaved}
              setBatchList={setbatchList}
              batchList={batchList}
              account={account}
            />
          </UserContext.Provider>
        </MyModal>
      )}
      {openSharePaymentModal && (
        <Dialog
          open={openSharePaymentModal}
          onClose={() => closeSharePaymentModal()}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <ShareDocumentsModal
            closeModal={closeSharePaymentModal}
            type={"sharePaymentLink"}
            accountId={account?._id}
            accountName={account?.family_name}
            defaultEmail={account?.defaultEmails || []}
            chargeId={dataRowSharePayment?.charge?._id}
            copyPaymentLink={copyPaymentLink}
            documentType="paymentLink"
          />
        </Dialog>
      )}
      <Dialog
        open={openPaymentMethodsModal}
        onClose={closeManagePaymentMethods}
        PaperProps={{
          style: {
            width: "888px",
            height: "600px",
            overflowX: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <ManagePaymentMethods
          closeModal={closeManagePaymentMethods}
          accountId={account?._id}
          handlePaymentOpen={handlePaymentOpen}
        />
      </Dialog>

      {paymentModal && (
        <Dialog
          open={paymentModal}
          onClose={() => closePaymentModal()}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <ShareDocumentsModal
            closeModal={() => closePaymentModal()}
            type={"updatePayment"}
            accountId={account?._id}
            accountName={account?.family_name}
            defaultEmail={account?.defaultEmails || []}
            chargeId={dataRowSharePayment?.charge?._id}
            copyPaymentLink={copyPaymentLink}
            documentType="paymentMethod"
          />
        </Dialog>
      )}

      {openConfirmEditInstallmentModal && (
        <NewDialog
          isOpen={openConfirmEditInstallmentModal}
          handleClose={() => {
            confirmEditTransaction.current = false;
            setOpenConfirmEditInstallmentModal(false);
            setTransactionRowData({});
          }}
          content={
            <p
              style={{
                textTransform: "none",
              }}
            >
              This charge is currently associated with an active payment plan.
              Click ‘Confirm' to cancel the existing payment plan and proceed
              with the editing.
            </p>
          }
        >
          <div className="payment-modal">
            <button
              className="payment-modal-btn"
              onClick={() => {
                setOpenConfirmEditInstallmentModal(false);
                setTransactionRowData({});
              }}
            >
              Cancel
            </button>
            <button
              className="payment-modal-btn payment-modal-btn-primary"
              onClick={() => {
                confirmEditTransaction.current = true;
                onUpdateClick(transactionRowData);
                setOpenConfirmEditInstallmentModal(false);
              }}
            >
              Confirm
            </button>
          </div>
        </NewDialog>
      )}
      <AlertDialog
        open={openConfirmCancelInstallmentModal}
        onDecline={() => {
          setTransactionRowData({});
          setOpenConfirmCancelInstallmentModal(false);
        }}
        onAccept={() => {
          confirmCancelInstallmentHandler();
        }}
        title={"Are you sure?"}
        content={"Do You want to cancel the installments?"}
      />

      <AlertDialog
        open={confirmClose}
        handleClose={() => setConfirmClose(false)}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseFinanceModal}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
      <MyModal
        className={"new-charge-modal"}
        open={updatePaymentMethod.open}
        onClose={closeUpdatePaymentMethod}
      >
        <UpdatePaymentMethod
          title="Update Payment Information"
          closeModal={closeUpdatePaymentMethod}
          accountId={updatePaymentMethod?.data?.Account?.id}
          isInstallment={
            updatePaymentMethod?.data?.charge?.isInstallment &&
            updatePaymentMethod?.data?.charge?.installmentDetails?.status ===
              "active"
          }
          data={updatePaymentMethod?.data}
          reFetchData={fetchMyAPI}
        />
      </MyModal>
    </div>
  );
};

export default memo(ChargesTable);
